import type { QuickSuggestion, ContactCTA } from '@brochure/shared'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: '1',
    labelKey: 'chatbot.suggestions.whatYouDo',
    messageKey: 'chatbot.suggestions.whatYouDoMessage',
  },
  {
    id: '2',
    labelKey: 'chatbot.suggestions.certifications',
    messageKey: 'chatbot.suggestions.certificationsMessage',
  },
  {
    id: '3',
    labelKey: 'chatbot.suggestions.whereAreYou',
    messageKey: 'chatbot.suggestions.whereAreYouMessage',
  },
  {
    id: '4',
    labelKey: 'chatbot.suggestions.catalog',
    messageKey: 'chatbot.suggestions.catalogMessage',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 */
export const contactCTAs: ContactCTA[] = [
  {
    kind: 'copy',
    id: 'phone',
    labelKey: 'chatbot.cta.phone',
    value: '+39 0172 98455',
  },
  {
    kind: 'copy',
    id: 'email',
    labelKey: 'chatbot.cta.email',
    value: 'info@boman.it',
  },
]
